import { ICartState } from './cartState.interface';

export const state = (): ICartState => {
    return {
        cartItems: [],
        orderId: null,
    };
};
